import { Absent_getInstance2zpu0zcae0yg1 as Absent_getInstance } from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Optional.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toString1pkumu07cwy4m as toString,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePlayerInputClass;
function SavePlayerInput() {
  if (SavePlayerInputClass === VOID) {
    class $ {
      constructor(partyId, playerId, name, email, badge, callSignAdjective, callSignNoun, imageURL, avatarType, unvalidatedEmails) {
        imageURL = imageURL === VOID ? Absent_getInstance() : imageURL;
        avatarType = avatarType === VOID ? Absent_getInstance() : avatarType;
        this.partyId_1 = partyId;
        this.playerId_1 = playerId;
        this.name_1 = name;
        this.email_1 = email;
        this.badge_1 = badge;
        this.callSignAdjective_1 = callSignAdjective;
        this.callSignNoun_1 = callSignNoun;
        this.imageURL_1 = imageURL;
        this.avatarType_1 = avatarType;
        this.unvalidatedEmails_1 = unvalidatedEmails;
      }
      toString() {
        return 'SavePlayerInput(partyId=' + this.partyId_1.toString() + ', playerId=' + this.playerId_1.toString() + ', name=' + this.name_1 + ', email=' + this.email_1 + ', badge=' + this.badge_1.toString() + ', callSignAdjective=' + this.callSignAdjective_1 + ', callSignNoun=' + this.callSignNoun_1 + ', imageURL=' + toString(this.imageURL_1) + ', avatarType=' + toString(this.avatarType_1) + ', unvalidatedEmails=' + toString(this.unvalidatedEmails_1) + ')';
      }
      hashCode() {
        var result = this.partyId_1.hashCode();
        result = imul(result, 31) + this.playerId_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.name_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.email_1) | 0;
        result = imul(result, 31) + this.badge_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.callSignAdjective_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.callSignNoun_1) | 0;
        result = imul(result, 31) + hashCode(this.imageURL_1) | 0;
        result = imul(result, 31) + hashCode(this.avatarType_1) | 0;
        result = imul(result, 31) + hashCode(this.unvalidatedEmails_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePlayerInput()))
          return false;
        if (!this.partyId_1.equals(other.partyId_1))
          return false;
        if (!this.playerId_1.equals(other.playerId_1))
          return false;
        if (!(this.name_1 === other.name_1))
          return false;
        if (!(this.email_1 === other.email_1))
          return false;
        if (!this.badge_1.equals(other.badge_1))
          return false;
        if (!(this.callSignAdjective_1 === other.callSignAdjective_1))
          return false;
        if (!(this.callSignNoun_1 === other.callSignNoun_1))
          return false;
        if (!equals(this.imageURL_1, other.imageURL_1))
          return false;
        if (!equals(this.avatarType_1, other.avatarType_1))
          return false;
        if (!equals(this.unvalidatedEmails_1, other.unvalidatedEmails_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePlayerInput');
    SavePlayerInputClass = $;
  }
  return SavePlayerInputClass;
}
//region block: exports
export {
  SavePlayerInput as SavePlayerInput3s7vno6nbe1ix,
};
//endregion

//# sourceMappingURL=SavePlayerInput.mjs.map
